// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".app-loading .logo {\n  width: 50px;\n  height: 50px;\n  background-size: cover;\n}", "",{"version":3,"sources":["styles-app-loading.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAAJ","file":"styles-app-loading.scss","sourcesContent":[".app-loading {\n  .logo {\n    width: 50px;\n    height: 50px;\n    background-size: cover;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
